export const SkillSourceType = {
    INDUSTRY_ROLE: 'Industry Role' ,
    ADD_SKILL: 'Add Skill',
    SKILL_MATCH: 'Skill Match',
    INFERRED_SKILL: 'Inferred Skill',
}